// Normalises ``project.cover_url`` into a usable ``<img src>``.
//
// The backend stores cover URLs as a free-form ``TextField`` so the
// shape varies by how the cover was uploaded:
//   * Absolute URL (``http://`` / ``https://`` / ``//``) — pass-through.
//   * Data URI (``data:image/...``) or object URL (``blob:``) — also
//     pass-through; callers may have just stored a base64 or local
//     blob.
//   * Backend-relative path (``/media/...`` from Django's MEDIA_URL,
//     or ``/api/...`` for an API-served stream) — prefix with
//     ``API_BASE`` so the browser hits the Django server, not the
//     Vite dev server (which doesn't serve ``/media/``).
//   * Empty / null — returns an empty string so the caller can drop
//     the ``<img>`` and render a placeholder instead of triggering a
//     broken-image glyph.
//
// Without this normaliser the dashboard project list and the search
// book card both rendered a 404 "broken image" icon for any project
// whose cover was uploaded as a relative path, because they shoved
// the raw value straight into ``<img src=...>``.
import { API_BASE } from './config';

export function coverSrc(value) {
  if (!value || typeof value !== 'string') return '';
  const trimmed = value.trim();
  if (!trimmed) return '';
  if (
    trimmed.startsWith('http://') ||
    trimmed.startsWith('https://') ||
    trimmed.startsWith('//') ||
    trimmed.startsWith('data:') ||
    trimmed.startsWith('blob:')
  ) {
    return trimmed;
  }
  if (trimmed.startsWith('/')) {
    return `${API_BASE}${trimmed}`;
  }
  // Anything else (a bare filename, etc.) is best-effort treated as a
  // backend-relative path — prepend a slash so it lands on Django.
  return `${API_BASE}/${trimmed}`;
}
